import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { loadApEmbedSession } from './api';
import { ApEmbedHideFlags } from './types';

type UseApEmbedIframeUrlParams = {
  hideFlags?: ApEmbedHideFlags;
  initialRoute?: string;
  options?: UseQueryOptions<string, Error>;
};

export function useApEmbedIframeUrl({ hideFlags, initialRoute, options }: UseApEmbedIframeUrlParams = {}) {
  return useQuery<string, Error>({
    queryKey: ['ap_embed_iframe_url'],
    queryFn: () => loadApEmbedSession(hideFlags, initialRoute),
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    ...options
  });
}
